import BaseModel from "./base.model";

export default class ProductModel extends BaseModel {
  
  defaultObj() {
    this.id = 0;
    this.name = '';
    this.type = null;
    this.is_bundle = false;
    this.price = 0;
    this.description = '';
    this.is_popular = false;
    this.is_special = false;
    this.is_legacy = false;
    this.terms = '';
    this.start_date = null;
    this.end_date = null;
    this.fup = false;
    this.is_imei = '';
    this.credit_limit = 0;
    this.is_recurring = false;
    this.display_details = null;
    this.tag = '';
    this.deal_name_id = '';
    this.product_type = null
  }

  constructor (data) {
    super();
    if (this.isEmpty(data)) return null;
    this.id = data.id;
    this.name = data.name;
    this.type = data.type;
    this.is_bundle = data.is_bundle;
    this.price = data.price;
    this.description = data.description;
    this.is_popular = data.is_popular;
    this.is_special = data.is_special;
    this.is_legacy = data.is_legacy;
    this.is_show = data.is_show;
    this.terms = data.terms;
    this.start_date = data.start_date;
    this.end_date = data.end_date;
    this.fup = data.fup;
    this.is_imei = data.is_imei;
    this.credit_limit = data.credit_limit;
    this.is_recurring = data.is_recurring;
    this.display_details = data.display_details;
    this.tag = data.tag;
    this.deal_name_id = data.deal_name_id;
    this.product_type = data.product_type;
  }
}
